<div class="fakturnia-vertical-navigation-wrapper">

    <!-- Header -->
    <div class="fakturnia-vertical-navigation-header">
        <ng-content select="[fakturniaVerticalNavigationHeader]"></ng-content>
    </div>

    <!-- Content -->
    <div
        class="fakturnia-vertical-navigation-content"
        fakturniaScrollbar
        [fakturniaScrollbarOptions]="{wheelPropagation: inner, suppressScrollX: true}"
        #navigationContent>

        <!-- Content header -->
        <div class="fakturnia-vertical-navigation-content-header">
            <ng-content select="[fakturniaVerticalNavigationContentHeader]"></ng-content>
        </div>

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside'">
                    <fakturnia-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name || ''"
                        [activeItemId]="activeAsideItemId || ''"
                        [autoCollapse]="autoCollapse"
                        [skipChildren]="true"
                        (click)="toggleAside(item)"></fakturnia-vertical-navigation-aside-item>
                </ng-container>

                <!-- Basic -->
                <ng-container *ngIf="item.type === 'basic'">
                    <fakturnia-vertical-navigation-basic-item
                        [item]="item"
                        [name]="name || ''"></fakturnia-vertical-navigation-basic-item>
                </ng-container>

                <!-- Collapsable -->
                <ng-container *ngIf="item.type === 'collapsable'">
                    <fakturnia-vertical-navigation-collapsable-item
                        [item]="item"
                        [name]="name || ''"
                        [autoCollapse]="autoCollapse"></fakturnia-vertical-navigation-collapsable-item>
                </ng-container>

                <!-- Divider -->
                <ng-container *ngIf="item.type === 'divider'">
                    <fakturnia-vertical-navigation-divider-item
                        [item]="item"
                        [name]="name || ''"></fakturnia-vertical-navigation-divider-item>
                </ng-container>

                <!-- Group -->
                <ng-container *ngIf="item.type === 'group'">
                    <fakturnia-vertical-navigation-group-item
                        [item]="item"
                        [name]="name || ''"
                        [autoCollapse]="autoCollapse"></fakturnia-vertical-navigation-group-item>
                </ng-container>

                <!-- Spacer -->
                <ng-container *ngIf="item.type === 'spacer'">
                    <fakturnia-vertical-navigation-spacer-item
                        [item]="item"
                        [name]="name || ''"></fakturnia-vertical-navigation-spacer-item>
                </ng-container>

            </ng-container>

        </ng-container>

        <!-- Content footer -->
        <div class="fakturnia-vertical-navigation-content-footer">
            <ng-content select="[fakturniaVerticalNavigationContentFooter]"></ng-content>
        </div>

    </div>

    <!-- Footer -->
    <div class="fakturnia-vertical-navigation-footer">
        <ng-content select="[fakturniaVerticalNavigationFooter]"></ng-content>
    </div>

</div>

<!-- Aside -->
<ng-container *ngIf="activeAsideItemId">
    <div
        class="fakturnia-vertical-navigation-aside-wrapper"
        fakturniaScrollbar
        [fakturniaScrollbarOptions]="{wheelPropagation: false, suppressScrollX: true}"
        [@fadeInLeft]="position === 'left'"
        [@fadeInRight]="position === 'right'"
        [@fadeOutLeft]="position === 'left'"
        [@fadeOutRight]="position === 'right'">

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside' && item.id === activeAsideItemId">
                    <fakturnia-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name || ''"
                        [autoCollapse]="autoCollapse"></fakturnia-vertical-navigation-aside-item>
                </ng-container>

            </ng-container>

        </ng-container>

    </div>
</ng-container>
